import { render, staticRenderFns } from "./IconCodeBranch.vue?vue&type=template&id=a74ea716&"
import script from "./IconCodeBranch.vue?vue&type=script&lang=ts&"
export * from "./IconCodeBranch.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports